import { render } from "./ContentTagSelect.vue?vue&type=template&id=64ccf936"
import script from "./ContentTagSelect.vue?vue&type=script&lang=js"
export * from "./ContentTagSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__